"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = exports["default"] = {
  displayInline: 'inline',
  displayNone: 'none',
  textTransformUpperCase: 'uppercase',
  textTransformNone: 'none',
  fontWeightBold: 'bold',
  fontWeightNormal: 'normal',
  fontStyleItalic: 'italic',
  fontStyleNormal: 'normal',
  textDecorationUnderline: 'underline',
  textDecorationNone: 'none',
  textOverflowEllipsis: 'ellipsis',
  textOverflowNone: '',
  textAlignLeft: 'left',
  textAlignCenter: 'center',
  textAlignRight: 'right'
};